import React from 'react';
import styled from '@emotion/styled';

const IconPrimitive = styled.div`
  display: inline;
`;

export const Icon = ({
  svg,
  className,
}: {
  svg: string;
  className?: string;
}) => {
  return (
    <IconPrimitive
      className={className}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
